import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]

import { ref } from 'vue';
import { useContextMenuStore } from '@/stores/context-menu';
import { useResizeObserver } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheContextMenu',
  setup(__props) {

const menuRef = ref<HTMLElement>()
const contextMenu = useContextMenuStore()

const onMenuClick = (e: MouseEvent) => {
  const target = e.target as HTMLElement
  if (target.tagName === "BUTTON" || target.parentElement?.tagName === "BUTTON") {
    contextMenu.opened = false
  }
}
useResizeObserver(menuRef, (res) => {
  contextMenu.attachObject(menuRef)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(contextMenu).opened)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "v-select-backdrop",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(contextMenu).opened = false))
        }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "grow" }, {
      default: _withCtx(() => [
        (_unref(contextMenu).opened)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "v-select-menu origin-top-center scroll",
              style: _normalizeStyle(_unref(contextMenu).style),
              ref_key: "menuRef",
              ref: menuRef,
              onClick: onMenuClick
            }, [
              _renderSlot(_ctx.$slots, "top"),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contextMenu).menuItems, (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: _normalizeClass(["v-select-menu__button", { selected: item.selected }]),
                  onClick: item.onClick
                }, _toDisplayString(item.title), 11, _hoisted_1))
              }), 256))
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})